export function getConnectParams() {
  const defaultValue = {
    response_type: '',
    client_id: '',
    redirect_uri: '',
    scope: '',
    state: '',
  }
  const _connectParams = sessionStorage.getItem('connect-params')
  if (_connectParams) {
    try {
      const connectParams = JSON.parse(_connectParams) || defaultValue
      return connectParams as typeof defaultValue
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
      return defaultValue
    }
  }
  return defaultValue
}
